import Vue from 'vue';
import axios from 'axios';
import q from 'q';
import Cookie from 'js-cookie'
import { Message } from 'element-ui';

axios.defaults.crossDomain = true;
axios.defaults.withCredentials = true;

function request(config) {
  let { url } = config;
  const MK_USER_ID = Cookie.get('MK_USER_ID');

  if (MK_USER_ID) {
    url = url + '?userID=' + MK_USER_ID
  }
  const _config = {
    baseURL: process.env.VUE_APP_API_HOST,
    ...config,
    url, 
  };

  return q
    .resolve(
      axios(_config)
        .then((res) => {
          if (res.status === 200) return res.data;
          throw new Error(`服务端错误，状态码: ${res.status}`);
        })
        .then((res) => {
          if (!res) {
            throw new Error('服务端错误');
          }
          if (!res.code) return res;
          switch (res.code) {
            case 200:
              return res;
            case 40000:
            case 2001:
            case 2002: // 登录态失效/账号禁用/sso登录失败等
              Vue.ls.set('uid', '');
              Vue.ls.set('username', '');
              Vue.ls.set('company', '');
              return res;
            case 2009:
              throw new Error('该账号未注册，请联系对应销售');
            case 30000:
              return res;
          }
          throw new Error(res.message || '请求错误');
        }),
    )
    .catch((e) => {
      Message.error(e.message);
      return q.reject(e);
    });
}

export default request;
